import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { View } from '../View';
import Text from '../Text';
import Checkbox from '../Checkbox';

import { styleUtils } from '../../utils';

import styles from './styles';

const { style } = styleUtils;

const Container = style(View, styles.container);
const SCheckbox = style(Checkbox, styles.checkbox);
const SMessage = style(Text, styles.message);

class CheckboxGroup extends Component {
  constructor(props) {
    super(props);
    const { group } = this.props;
    const groupChecked = group.reduce((acc, { name, checked = false }) => {
      acc[name] = checked;
      return acc;
    }, {});
    this.state = {
      ...groupChecked
    };
  }

  handleOnChange = (name, checked) => {
    const { onChange } = this.props;
    this.setState({ [name]: checked });
    onChange && onChange(name, checked);
  };

  render() {
    const { group, message, error } = this.props;

    return (
      <Container>
        {group.map(({ name, label, ...restOfProps }) => (
          <SCheckbox
            key={name}
            name={name}
            onChange={this.handleOnChange}
            error={error}
            {...restOfProps}
          >
            {label}
          </SCheckbox>
        ))}
        <Message message={message} error={error} />
      </Container>
    );
  }
}

const Message = ({ message, error }) =>
  message ? (
    <SMessage error={error} size="small">
      {message}
    </SMessage>
  ) : null;

CheckboxGroup.propTypes = {
  name: PropTypes.string.isRequired,
  group: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      checked: PropTypes.bool,
      disabled: PropTypes.bool
    })
  ),
  message: PropTypes.string,
  error: PropTypes.bool,
  onChange: PropTypes.func
};

CheckboxGroup.defaultProps = {
  error: false
};

export default CheckboxGroup;
